import { StringParam, useQueryParam, withDefault } from 'use-query-params';
import React, { useState, useEffect } from 'react';
import { STEPS, STEPS_PAGE_TITLES } from '../constants';
import {
  STEPS_FOUR_STAGES,
  STEPS_PAGE_TITLES_FOUR_STAGES,
} from '../constants_four_stages';
import PcModelStepsStep from '../PcModelStepsStep';
import PcModelStepsStepMobile from '../PcModelStepsStepMobile';
import styles from './styles';
import { usePcConfigurator } from 'utils/PcConfiguratorContext';

const PcModelSteps = ({
  navbar,
  navbarTablet,
  navbarMobile,
  handleTabClick,
}) => {
  let UPDATED_STEPS = STEPS;
  let UPDATED_STEPS_PAGE_TITLES = STEPS_PAGE_TITLES;

  const { options } = usePcConfigurator();
  const optionsFourStages = ['build', 'ultra-labs', 'accessories (new)'];
  let isInArray = false;

  if (options?.length != 0) {
    isInArray = optionsFourStages.includes(options[0].group_step_new);
    if (isInArray) {
      UPDATED_STEPS = STEPS_FOUR_STAGES;
      UPDATED_STEPS_PAGE_TITLES = STEPS_PAGE_TITLES_FOUR_STAGES;
    } else {
      UPDATED_STEPS = STEPS;
      UPDATED_STEPS_PAGE_TITLES = STEPS_PAGE_TITLES;
    }
  }

  const [currentStep] = useQueryParam(
    'step',
    withDefault(StringParam, UPDATED_STEPS[0]),
  );

  const [currentIndex, setCurrentIndex] = useState(null);
  const [initialRender, setInitialRender] = useState(true);

  const findStepIndex = (step) =>
    UPDATED_STEPS.findIndex((item) => item === step);

  // Catching query param and setting actual step
  useEffect(() => {
    const index = findStepIndex(currentStep);
    setCurrentIndex(index);

    if (initialRender) {
      handleTabClick(index);
      setInitialRender(false);
    }
  }, [currentStep, findStepIndex, initialRender]);

  return (
    <>
      <div className={`steps-container ${navbar ? 'fixed_nav' : ''}`}>
        <div className='pc-model-config-header wrapper'>
          {UPDATED_STEPS_PAGE_TITLES[currentStep]}
        </div>

        <div
          className={
            isInArray
              ? `steps step_4stages_${currentIndex}`
              : `steps step${currentIndex}`
          }
        >
          {UPDATED_STEPS.map((step) => {
            const index = findStepIndex(step);

            return (
              <PcModelStepsStep
                key={step}
                step={step}
                completed={index < currentIndex}
                active={index <= currentIndex}
                currentStep={currentStep}
                handleTabClick={handleTabClick}
              />
            );
          })}
        </div>
      </div>

      <div
        className={`steps-container-tablet ${
          navbarTablet ? 'fixed_nav_tablet' : ''
        }`}
      >
        <div className='pc-model-config-header wrapper'>
          {UPDATED_STEPS_PAGE_TITLES[currentStep]}
        </div>

        <div
          className={
            isInArray
              ? `steps step_4stages_${currentIndex}`
              : `steps step${currentIndex}`
          }
        >
          {UPDATED_STEPS.map((step) => {
            const index = findStepIndex(step);

            return (
              <PcModelStepsStep
                key={step}
                step={step}
                completed={index < currentIndex}
                active={index <= currentIndex}
                currentStep={currentStep}
              />
            );
          })}
        </div>
      </div>

      <div
        className={`steps-container-mobile ${
          navbarMobile ? 'fixed_nav_mobile' : ''
        }`}
      >
        <div className='pc-model-config-header wrapper'>
          {UPDATED_STEPS_PAGE_TITLES[currentStep]}
        </div>

        <div
          className={
            isInArray
              ? `steps step_4stages_${currentIndex}`
              : `steps step${currentIndex}`
          }
        >
          {UPDATED_STEPS.map((step) => {
            const index = findStepIndex(step);

            return (
              <PcModelStepsStepMobile
                key={step}
                step={step}
                completed={index < currentIndex}
                active={index <= currentIndex}
                currentStep={currentStep}
                showTitle={index === currentIndex}
              />
            );
          })}
        </div>
      </div>
      {/* {['chassis', 'build'].includes(currentStep) && (
        <div className="old-steps-warning-container">
          <div className="old-steps-warning-text">
            We have updated the configurator. Sorry, the link you are using no
            longer works. Please use the new steps to build your Rig.
          </div>
        </div>
      )} */}

      <style jsx>{styles}</style>
    </>
  );
};

export default PcModelSteps;
